var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.175 23C6.84198 23 6.24061 23 5.8 23C4.375 23 3.9 22.5 3.9 21C3.9 19.5 3.9 13 3.9 13H2L11.5 3L21 13H19.1C19.1 13 19.1 19.5 19.1 21C19.1 22.5 18.625 23 17.2 23C15.775 23 16.0806 23 14.825 23M8.175 23C8.175 23 8.175 17 8.175 16C8.175 15 9.125 14 10.075 14C11.025 14 11.975 14 12.925 14C13.875 14 14.825 15 14.825 16C14.825 17 14.825 23 14.825 23M8.175 23C9.9187 23 13.0515 23 14.825 23",
    stroke: "#979AA8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3L25 13H23.2C23.2 13 23.2 19.5 23.2 21C23.2 22.5 22.75 23 21.4 23C20.05 23 21.6895 23 20.5 23",
    stroke: "#979AA8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunities);
export default __webpack_public_path__ + "static/media/communities.463292689db59755c4bf618d38f29d2f.svg";
export { ForwardRef as ReactComponent };